import PopulationHeaderPanel, { IpcIndicator } from './PopulationHeaderPanel';

export { IpcIndicator };
export default PopulationHeaderPanel;
